<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :width="width"
    :before-close="handleClose" :close-on-click-modal="false">
    <div v-if="contentType === 'text'" v-html="content"></div>
    <div v-if="contentType === 'url'" style="height: 60vh;">
      <iframe :src="content" frameborder="0" width="100%" height="100%"></iframe>
    </div>
    <span slot="footer" class="dialog-footer">
      <span v-if="disabled">阅读倒计时: {{ count }} 秒</span>
    <el-button :disabled="disabled" @click="handleCancel">取 消</el-button>
    <el-button :disabled="disabled" type="primary" @click="handleConfirm">确 定</el-button>
  </span>
  </el-dialog>
</template>

<script>
export default {
  name: "ConfirmDialog",
  data() {
    return {
      title: "提示",
      content: "",
      contentType: "text",
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      delayTimer: null,
      disabled: false,
      width: "30%",
      confirmFn:null,
      cancelFn:null,
      dialogVisible: false,
      //倒计时
      count: 0,
      timer: null
    };
  },
  methods: {
    show({
           title="提示",
           content="",
           confirmButtonText="确定",
           cancelButtonText="取消",
           delayTimer=0,
           width="30%",
           confirmFn,
           cancelFn
    }) {
      const that = this;
      that.title = title;
      if(content.includes("http")||content.includes("https")){
        that.contentType = "url";
      }
      that.content = content;
      that.confirmButtonText = confirmButtonText;
      that.cancelButtonText = cancelButtonText;
      that.width = width;
      that.delayTimer = delayTimer;
      that.confirmFn = confirmFn;
      that.cancelFn = cancelFn;
      that.dialogVisible = true;
      if (delayTimer > 0) {
        that.startTimer();
      }
    },
    handleClose() {
      this.cancelFn=null;
      this.confirmFn=null;
      this.dialogVisible = false;
      this.$emit("close");
    },
    handleConfirm() {
      this.confirmFn();
      this.dialogVisible = false;
    },
    handleCancel() {
      this.cancelFn();
      this.dialogVisible = false;
    },
    //倒计时
    startTimer() {
      const that = this;
      that.count = that.delayTimer;
      that.disabled = true;
      that.timer = setInterval(() => {
        that.count--;
        if (that.count <= 0) {
          clearInterval(that.timer);
          that.disabled = false;
        }
      }, 1000);
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/common/ConfirmDialog.vue